import Vue from "vue";
import { insider } from "../../app.config.json";
Vue.prototype.$insider = new Vue({
    data() {
        return {
            ativo: true,
        };
    },
    methods: {
        async init() {
            const configs = await this.$http.post("CONFIGS");
            this.ativo = configs.insider_ativo;
            if (this.ativo) {
                window.InsiderQueue = window.InsiderQueue || [];
                const script = document.createElement("script");
                script.src = `https://${insider.partnerName}.api.useinsider.com/ins.js?id=${insider.partnerId}`;
                script.setAttribute("async", true);
                document.head.prepend(script);
                console.warn("Insider tag inicializado");
            } else {
                console.warn("Insider não está ativo");
            }
        },
        // Deve ser chamado uma vez por página/navegação: envia o type de página
        // (home, category, product, cart, purchase, other) seguido de type "init",
        // conforme exigido pela doc da Insider para disparar o pageview.
        page(type, value) {
            if (!this.ativo) return;
            window.InsiderQueue = window.InsiderQueue || [];

            // Origem do login (app x web) - mesmo atributo já usado em
            // identifyUserFromSession, vai em toda página que tiver "custom".
            if (value?.custom) {
                value.custom.origem_app = Vue.prototype.$util?.isApp() ?? false;
            }

            const pageData = value ? { type, value } : { type };
            window.InsiderQueue.push(pageData);
            window.InsiderQueue.push({ type: "init" });

            // Depois de qualquer purchase (ticket, associação ou parcela),
            // o carrinho na Insider não faz mais sentido - limpa. Espera um
            // pouco pra não competir com o processamento do próprio purchase.
            if (type === "purchase") {
                setTimeout(() => this.clearCart(), 500);
            }
        },
        // Identifica o usuário (type "user"). Não dispara "init" - o dado fica
        // preservado na sessão da Insider e é aproveitado no próximo pageview.
        // Ao menos um de uuid, email ou phone_number deve ser informado.
        identifyUser(userData = {}) {
            if (!userData.uuid && !userData.email && !userData.phone_number) {
                console.warn(
                    "Insider.identifyUser: informe ao menos uuid, email ou phone_number para identificar o usuário."
                );
                return;
            }
            window.InsiderQueue = window.InsiderQueue || [];
            window.InsiderQueue.push({ type: "user", value: userData });
        },
        // Monta o payload "user" a partir do objeto de sessão retornado pelo
        // login/GETPERFIL (mesmo shape salvo em $storage "session").
        identifyUserFromSession(session) {
            if (!session) return;

            const genderMap = { Masculino: "M", Feminino: "F" };

            // Campos já mapeados para atributos nativos da Insider, mais os que
            // não fazem sentido como atributo de usuário (opções de UI/metadados
            // de formulário, não dado da pessoa) - o resto vira "custom".
            const {
                idpessoa,
                email,
                celular,
                nome,
                dt_nascimento,
                sexo_dsc,
                end_cidade,
                end_pais,
                newsletter,
                foto,
                rg_ufs,
                required_fields,
                ...custom
            } = session;

            const lang = Vue.prototype.$lang_?.get();

            // Campanha da Insider (vinda da URL via app, ver router/index.js),
            // persistida em sessionStorage - segue junto com o usuário.
            const insiderId = sessionStorage.getItem("insider_id");
            const insiderTitle = sessionStorage.getItem("insider_title");

            // A API só devolve o nome completo num único campo - a Insider
            // espera "name" (primeiro nome) e "surname" (resto) separados.
            const [primeiroNome, ...resto] = (nome || "").trim().split(/\s+/);
            const sobrenome = resto.join(" ");

            this.identifyUser({
                uuid: idpessoa,
                idpessoa: idpessoa,
                id_pessoa: idpessoa,
                email: email,
                phone_number: celular || undefined,
                name: primeiroNome || undefined,
                surname: sobrenome || undefined,
                birthday: dt_nascimento
                    ? `${dt_nascimento}T00:00:00Z`
                    : undefined,
                gender: genderMap[sexo_dsc],
                city: end_cidade,
                country: end_pais,
                email_optin: newsletter === "1",
                language: lang ? lang.replace("-", "_") : undefined,
                custom: {
                    idpessoa: idpessoa,
                    id_pessoa: idpessoa,
                    id_person: idpessoa,
                    ...custom,
                    notification_id: insiderId || undefined,
                    notification_title: insiderTitle || undefined,
                    // Origem do login (app x web) - já capturado via query
                    // string pelo router (ver router/index.js) e exposto em
                    // $util.isApp().
                    isAppLogin: Vue.prototype.$util
                        ? Vue.prototype.$util.isApp()
                        : false,
                    origem_app: Vue.prototype.$util
                        ? Vue.prototype.$util.isApp()
                        : false,
                },
            });
        },
        // Define a moeda (type "currency"), usada pela Insider para converter
        // preços em eventos/campanhas. Não dispara "init" - fica preservada
        // igual ao "user", até o próximo pageview.
        setCurrency(currency = "BRL") {
            window.InsiderQueue = window.InsiderQueue || [];
            window.InsiderQueue.push({ type: "currency", value: currency });
        },
        // Mesma lista "produtos" usada no Google.controller.js (tratarProdutos),
        // convertida para o formato de item exigido pela Insider. Como não há
        // url/imagem por produto disponível nesse fluxo, cai no fallback abaixo.
        tratarProdutos(produtos = []) {
            let items = [];
            produtos.forEach((item) => {
                const price = Number(item.total || 0);
                const existente = items.find(
                    (i) => i.id == String(item.idproduto)
                );

                if (existente) {
                    existente.quantity += 1;
                } else {
                    // tpproduto/info_acesso complementam o nome do produto
                    // (ex.: "Meia-entrada Estudante") quando o item da
                    // reserva trouxer esse detalhe extra.
                    const descricaoProduto = [
                        item.dscproduto,
                        item.tpproduto || item.info_acesso,
                    ]
                        .filter(Boolean)
                        .join(" ");

                    items.push({
                        id: String(item.idproduto),
                        // Mesmo formato do "product" (Mapa.mixeds.js) quando
                        // tem o setor/bloco (add_to_cart, remove_from_cart) -
                        // cai pro nome com o evento quando não tem (purchase,
                        // cart, que vêm do pedido/reserva já finalizado).
                        name: item.dscapre
                            ? `${descricaoProduto} - ${item.dscapre}`
                            : item.dsceven
                            ? `${item.dsceven} - ${descricaoProduto}`
                            : descricaoProduto,
                        // Mesma lógica do name: usa a partida (dscapresentacao)
                        // quando disponível, igual ao "product".
                        taxonomy: [
                            "Tickets/Online",
                            item.dsceven,
                            item.dscapresentacao || item.dscproduto,
                        ],
                        unit_price: price,
                        unit_sale_price: price,
                        quantity: 1,
                        url: window.location.href,
                        product_image_url:
                            "https://internacionalcloudfront.eleventickets.com/img-Internacional/logo-inter-transparente.png",
                    });
                }
            });

            return items;
        },
        // Equivalente ao view_item_list/select_content/add_to_cart do GTM:
        // um push "add_to_cart" por produto distinto do carrinho.
        addToCart(produtos = []) {
            this.tratarProdutos(produtos).forEach((item) => {
                window.InsiderQueue = window.InsiderQueue || [];
                window.InsiderQueue.push({ type: "add_to_cart", value: item });
            });
        },
        // Equivalente ao remove_from_cart do GTM.
        removeFromCart(produtos = []) {
            this.tratarProdutos(produtos).forEach((item) => {
                window.InsiderQueue = window.InsiderQueue || [];
                window.InsiderQueue.push({
                    type: "remove_from_cart",
                    value: item,
                });
            });
        },
        // Equivalente ao checkout_progress do GTM: não existe esse evento na
        // Insider, então atualiza o carrinho (type "cart") antes do pagamento.
        updateCart(produtos = []) {
            const items = this.tratarProdutos(produtos);
            const total = items.reduce(
                (soma, item) => soma + item.unit_sale_price * item.quantity,
                0
            );

            this.page("cart", { total: Number(total.toFixed(2)), items });
        },
        // Equivalente ao purchase do GTM: dispara a página de compra concluída.
        // "extra" é mesclado no value (ex.: { coupon } quando um cupom foi usado).
        purchase(produtos, idmovimentacao, extra = {}) {
            const items = this.tratarProdutos(produtos);
            const total = items.reduce(
                (soma, item) => soma + item.unit_sale_price * item.quantity,
                0
            );

            this.page("purchase", {
                order_id: String(idmovimentacao),
                total: Number(total.toFixed(2)),
                items,
                ...extra,
            });
        },
        // Esvazia o carrinho na Insider - usado quando a compra é travada
        // depois de um add_to_cart (ex.: limite de ingressos atingido no
        // backend), pra não deixar um carrinho "fantasma" registrado lá.
        clearCart() {
            window.InsiderQueue = window.InsiderQueue || [];
            window.InsiderQueue.push({
                type: "cart",
                value: {
                    total: 0,
                    shipping_cost: 0,
                    items: [],
                },
            });
        },
        // add_to_cart pra um item que não segue o formato de ingresso (ex.:
        // plano de sócio) - recebe o item já pronto no formato da Insider.
        addToCartItem(item) {
            if (!this.ativo) return;
            window.InsiderQueue = window.InsiderQueue || [];
            window.InsiderQueue.push({ type: "add_to_cart", value: item });
        },
        // Evento genérico (type "custom_event"). Não dispara "init" e não
        // define página - use pra ações que não são pageview nem add/remove
        // de carrinho (ex.: início de checkout, cliques específicos).
        customEvent(eventName, params = {}) {
            window.InsiderQueue = window.InsiderQueue || [];
            const eventParameters = {
                ...params,
                origem_app: Vue.prototype.$util
                    ? Vue.prototype.$util.isApp()
                    : false,
            };
            window.InsiderQueue.push({
                type: "custom_event",
                value: [
                    {
                        event_name: eventName,
                        event_parameters: eventParameters,
                    },
                ],
            });
        },
    },
});
Vue.prototype.$insider.init();
